import React from "react";
import QRCode from "react-qr-code";
import ReactDOMServer from "react-dom/server";

export class ImtexBadgeDimension extends React.Component {
  render() {
    const { row } = this.props;
    const vCard = row.barcode_id;
    return (
      <div
        style={{
          width: "9.5cm",
          height: "14cm", // Target only the top 14cm of the page
          margin: "0 auto",
          boxSizing: "border-box",
          paddingTop: "5cm", // This exactly skips the 5cm pre-printed top header
        }}
      >
        {/* This div is strictly locked to the 7.5cm white space area */}
        <div
          style={{
            height: "7.5cm",
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "flex-start",
            paddingTop: "0.5cm", // Gives a tiny breathing room below the 5cm line
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              fontWeight: "bold",
              fontSize: "21px",
              textAlign: "center",
              width: "100%",
            }}
          >
            {row.firstName?.toUpperCase()} {row.lastName?.toUpperCase()}
          </div>
          <div
            style={{
              fontSize: "19px",
              marginTop: "6px",
              textAlign: "center",
              width: "100%",
            }}
          >
            {row.companyName?.toUpperCase()}
          </div>
          <div style={{ marginTop: "12px" }}>
            {/* Reduced from 130 to 120 to guarantee it never overflows the 7.5cm limit */}
            <QRCode value={vCard} size={120} />
          </div>
        </div>
      </div>
    );
  }
}

export const printRow = (row, existingWindow = null) => {
  const printableContent = ReactDOMServer.renderToString(
    <ImtexBadgeDimension row={row} />
  );

  const printWindow = existingWindow || window.open("", "_blank");
  if (!printWindow) return;
  printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <style>
          body { 
            font-family: Arial, sans-serif; 
            margin: 0; 
            padding: 0; 
          }
          /* Setting the exact 9.5 x 28 cm paper length from your requirements */
          @page { 
            size: 9.5cm 28cm;
            margin: 0; 
          }
        </style>
      </head>
      <body>
        ${printableContent}
      </body>
      </html>
    `);
  printWindow.document.close();
  printWindow.focus();

  printWindow.onafterprint = () => {
    printWindow.close();
  };

  printWindow.print();
};

export const printAll = (rows, existingWindow = null) => {
  const printableContent = rows
    .map(
      (row) =>
        `<div class="page">
        ${ReactDOMServer.renderToString(<ImtexBadgeDimension row={row} />)}
      </div>`
    )
    .join("");

  const styles = `
    body { font-family: Arial, sans-serif; margin: 0; padding: 0; }
    @page {
      size: 9.5cm 28cm;
      margin: 0;
    }
    @media print {
      .page { page-break-after: always; }
    }
  `;

  const printWindow = existingWindow || window.open("", "_blank");
  if (!printWindow) return;
  printWindow.document.write(`
      <!DOCTYPE html>
      <html>
      <head>
        <style>
          ${styles}
        </style>
      </head>
      <body>
        ${printableContent}
      </body>
      </html>
    `);
  printWindow.document.close();
  printWindow.focus();

  printWindow.onafterprint = () => {
    printWindow.close();
  };

  printWindow.print();
};
